import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'wouter';
import { actions } from '@/store/store.js';
import { useCart } from "@/providers/CartProvider.jsx";

const shopContentName = 'shop-content';

const Shop = () => {
  const dispatch = useDispatch();
  const cart = useCart();

  useEffect(() => {
    dispatch(actions.salesProducts.loadAll());
    dispatch(actions.contentTemplates.loadOne({ name: shopContentName }));
  }, []);

  const shopProducts = useSelector(({ salesProducts }) => {
    return Object.values(salesProducts.records);
  });
  const shopContent = useSelector(({ contentTemplates }) => {
    return Object.values(contentTemplates.records).find((template) => {
      return template.name === shopContentName;
    });
  });

  return (
    <>
      {shopContent && (
        <div dangerouslySetInnerHTML={{ __html: shopContent.content_html }} />
      )}

      <hr className="my-4"/>

      {shopProducts.map(product => (
        <Link
          key={product.id}
          to={`/product/${product.identity}`}
          className="featured-product-card mb-4"
        >
          <div className='image-wrapper'>
            <img
              src={product.sales_square}
              alt={product.sales_name}
              className="featured-product-image image-1x1"
            />

            <img
              src={product.sales_3x2}
              alt={product.sales_name}
              className="featured-product-image image-3x2"
            />
          </div>
          <div className="featured-product-description">
            <h3 className="">
              {product.sales_name}
            </h3>
            <p className=''>
              {product.sales_description}
            </p>
          </div>
        </Link>
      ))}
    </>
  );
};

export default Shop;